import { render, staticRenderFns } from "./aide.vue?vue&type=template&id=a8c83776"
import script from "./aide.vue?vue&type=script&lang=ts"
export * from "./aide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports